(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapple-launch-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tapple-banner-video')) {
  customElements.define('tapple-banner-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.slide = this.closest('[data-tr-slide]');
      if (!this.video || !this.button || !this.slide) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reduced.matches || Boolean(navigator.connection?.saveData);
      this.visible = false;
      this.video.muted = true;
      this.video.playsInline = true;
      const refresh = () => {
        this.button.textContent = this.video.paused ? this.button.dataset.play : this.button.dataset.pause;
      };
      this.sync = () => {
        if (this.visible && !this.slide.inert && !document.hidden && !this.userPaused) {
          this.video.play().then(() => {
            if (!this.visible || this.slide.inert || document.hidden || this.userPaused) this.video.pause();
            refresh();
          }).catch(refresh);
        } else {
          this.video.pause();
          refresh();
        }
      };
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.sync();
      }, options);
      this.video.addEventListener('play', refresh, options);
      this.video.addEventListener('pause', refresh, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.reduced.addEventListener('change', () => {
        this.userPaused = this.reduced.matches;
        this.sync();
      }, options);
      this.visibility = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.2 });
      this.visibility.observe(this);
      this.active = new MutationObserver(this.sync);
      this.active.observe(this.slide, { attributes: true, attributeFilter: ['inert'] });
      this.resize = new ResizeObserver(() => {
        this.closest('[data-tr-slider]')?.style.setProperty('--tl-video-slide-height', `${this.getBoundingClientRect().height}px`);
      });
      this.resize.observe(this);
      refresh();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.abort?.abort();
      this.visibility?.disconnect();
      this.active?.disconnect();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapple-reference-rooms"] && !Shopify.designMode) return;
  try {
    
(()=>{if(window.tappleRoomCarousel)return;window.tappleRoomCarousel=true;
function setup(){document.querySelectorAll('[data-tx-carousel]').forEach(section=>{const track=section.querySelector('.tx-track');const prev=section.querySelector('[data-tx-prev]');const next=section.querySelector('[data-tx-next]');const update=()=>{
  prev.disabled=track.scrollLeft<2;
  next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
  const bounds=track.getBoundingClientRect();
  let visibleHeight=0;
  for(const card of track.children){
    const rect=card.getBoundingClientRect();
    if(rect.right>bounds.left+1&&rect.left<bounds.right-1) visibleHeight=Math.max(visibleHeight,rect.height);
  }
  if(visibleHeight){
    const styles=getComputedStyle(track);
    const height=Math.ceil(visibleHeight+parseFloat(styles.paddingTop)+parseFloat(styles.paddingBottom)+track.offsetHeight-track.clientHeight)+'px';
    if(track.style.height!==height) track.style.height=height;
  }
};if(!section.dataset.ready){section.dataset.ready='true';track.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(update);observer.observe(track);for(const card of track.children)observer.observe(card);section.addEventListener('click',e=>{const b=e.target.closest('[data-tx-prev],[data-tx-next]');if(!b)return;track.scrollBy({left:(b===prev?-1:1)*((track.firstElementChild?.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)||track.clientWidth)*(matchMedia('(min-width: 750px)').matches?3:1)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});}update();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tapple-reviews-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tl-review-slider')) {
  customElements.define('tl-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      this.querySelector('[data-next]')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => this.stop()));
      ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.restart()));
      this.restart();
    }
    disconnectedCallback() { this.stop(); }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => { s.hidden = n !== this.index; });
    }
    stop() { clearInterval(this.timer); }
    restart() {
      this.stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const seconds = Number(this.dataset.interval) || 6;
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
